import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { useQueryClient } from "react-query";

const useLogout = () => {
  const queryClient = useQueryClient();

  const handleLogout = () => {
    queryClient.clear();
    Cookies.set("jwt", "");
    localStorage.setItem("jwt", "");
    localStorage.setItem("upgradeAlertDismissed", "false");
  };

  useEffect(() => {}, []);

  return [handleLogout];
};

export default useLogout;
